export default __webpack_public_path__ + "static/media/graz4.fe8c88f4.png";